/* unplugin-vue-components disabled */
import {API2_USERS} from 'consts/api2'
import {Rest} from 'utils'

export default {
  mixins: [ModelValue(String)],
  props: {
    tenantId: {type: String, required: true},
    required: {type: Boolean, default: true}
  },
  data() {
    return {
      rest: new Rest(),
      el_value: undefined,
      el_item: undefined,
      last_query: undefined,
      last_res: undefined,
    }
  },
  computed: {
    empty() {
      return !this.value
    }
  },
  methods: {
    async loadAsync(query, cback) {
      if (query?.length < 3) return cback([])
      if (this.last_query == query) return cback(this.last_res)

      const {view_items} = await this.rest.get(API2_USERS, {limit: 10, filter: query})
      if (!view_items?.length) {
        this.last_query = query
        this.last_res = []
        return cback([])
      }
      
      const res = []
      for (let user of view_items) {
        res.push({
          label: this.formatLabel(user),
          value: user.id,
          raw: user
        })
      }

      this.last_query = query
      this.last_res = res
      cback(res)
    },
    formatLabel(user) {
      return `${user.email || '???'} (${user.name})`
    },
    onInput() {
      this.el_item = undefined
      this.value = undefined
    },
    onSelect(item) {
      this.el_item = item
      this.value = item.value
    }
  }
}
